<div class="flex items-center justify-center mr-4">
  <img
    class="w-6 cursor-pointer pb-0.5"
    [src]="languageFlagUrl"
  />
</div>
